export default {"src":"/_next/static/media/0xc1cba3fcea344f92d9239c08c0568f6f2f0ee452.9cba0cca.svg","height":146,"width":146,"blurWidth":0,"blurHeight":0};